import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import { AppBar, Toolbar, Typography, CircularProgress, Box, Link } from '@material-ui/core';
import logo from '../../logo.png';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { isLoading, getPreview, getError, resetPreview, fetchQRPreview } from './previews';
import { Row } from 'components/UI/Row';
import { AppStoreLinks } from './AppStoreLinks';
import { PreviewData } from './PreviewData';
import { RelatedResources } from './RelatedResources';

require('moment/locale/it');

const QRPreview: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector(isLoading);
  const preview = useSelector(getPreview);
  const error = useSelector(getError);

  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    dispatch(resetPreview);
    dispatch(fetchQRPreview({ q: query.get('c') || '', t: query.get('t') || '' }));
  }, []);

  if (!isEmpty(error)) {
    return (
      <>
        <AppBar>
          <Toolbar className="navColor">
            <img src={logo} alt="Logo" height="32" width="32" />
            <Typography variant="h6" style={{ paddingLeft: '1em' }}>
              Box-e
            </Typography>
          </Toolbar>
        </AppBar>
        <Box m={2}>
          <Row justifyContent="center">
            <Typography style={{ marginTop: 64 }} variant="h6">{error}</Typography>
          </Row>
          <AppStoreLinks />
        </Box>
      </>
    );
  }

  return (
    <>
      <AppBar>
        <Toolbar className="navColor">
          <img src={logo} alt="Logo" height="32" width="32" />
          <Typography variant="h6" style={{ paddingLeft: '1em' }}>
            Box-e
          </Typography>
        </Toolbar>
      </AppBar>
      <Box m={2}>
        {loading ? (
          <>
            <Row margin="0 0 16px" justifyContent="center">
              <Typography>{t('preview.loading')}</Typography>
            </Row>
            <Row justifyContent="center">
              <CircularProgress />
            </Row>
          </>
        ) : (
          <>
            {error ? (
              <Row justifyContent="center">
                <Typography style={{ marginTop: 64 }} variant="h6">{error}</Typography>
              </Row>
            ) : (
              <>
                <Row margin="64px" justifyContent="center"></Row>
                <PreviewData data={preview.data} />
                <RelatedResources relatedResources={preview.related_resources} />
                <AppStoreLinks />
              </>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default QRPreview;
